import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "forchbahn",
  name: "Forchbahn",
  slug: "forchbahn",
  ...colors,
};
export default config;
